export default __webpack_public_path__ + "static/media/contain.06892f0c.svg";